<template>
  <router-view></router-view>
</template>

<script>
  export default {
    name: 'app',

    head: {
      title: {
        inner: 'flew - フルー -',
        separator: '|',
        complement: 'CAD作図専門のクラウドソーシングサイト'
      },
      meta: [
        {name: 'description', content: '設計者・エンジニアと、CADオペレーターをつなぐCAD作図専門のクラウドソーシングサイト'},
        {property: 'og:description', content: '設計者・エンジニアと、CADオペレーターをつなぐCAD作図専門のクラウドソーシングサイト'},
      ],
    }
  }
</script>
